import CheckmarkSvg from "src/components/svg/CheckMarkSvg";
import classNames from 'classnames';
import styles from './LabelledCheck.module.css';
import getThemeStyles from "src/lib/styling/getThemeStyles";

//#region [Props]
type LabelledCheckProps = {
	className?: string;
	selected?: boolean;
	selectionCallback: (isSelected: boolean) => void;
	value: string | number;
	label?: string;
	hideCheckmark?: boolean;
	dkVariant?: "darkOutline"
};
//#endregion

//#region [Component]
export default function LabelledCheck({ className, selected = false, selectionCallback, value, label, hideCheckmark, dkVariant }: LabelledCheckProps) {
	const themeStyles = getThemeStyles(styles, {
        [styles.selected]: selected,
        "selected": selected,
		[styles.DarkOutlineVariant]: dkVariant === "darkOutline",
		[styles.NoCheckmark]: hideCheckmark
    });
    return <label className={className}>
        <input className={styles.SCheckInput} type="checkbox" checked={selected} onChange={() => selectionCallback(!selected)} value={value} />
        <span className={classNames(styles.SLabelSpan, themeStyles)}>
            {!hideCheckmark && selected && <CheckmarkSvg className={styles.SCheckMarkSvg} />} {label ?? value}
        </span>
    </label>;
}
//#endregion

//#region [Styles]
//#endregion
